module.exports = __webpack_public_path__ + "img/warn.16aaa28f.png";